// assets/popup-notification.js
class PopupNotification extends HTMLElement {
  connectedCallback() {
    if (this.__mounted) return;
    this.__mounted = true;
    this.__closed = false;

    this.cfg = this.readConfig();
    if (!this.cfg.enabled) return;
    if (!this.shouldShowOnThisPage()) return;
    if (this.cfg.mobileOnly && !this.isMobile()) return;

    this.products = this.readProducts();
    if (!this.products.length) return;

    this.users = this.parseList(this.cfg.usersRaw, 'Someone');
    this.times = this.parseList(this.cfg.timesRaw, 'Just now');

    if (this.cfg.position === 'right') this.classList.add('is-right');

    setTimeout(() => this.start(), this.cfg.startDelayMs);
  }

  readConfig() {
    const b = v => String(v) === 'true';
    const n = (v, d) => Number.isFinite(+v) ? +v : d;

    return {
      enabled: b(this.dataset.enabled),
      mobileOnly: b(this.dataset.mobileOnly),
      position: this.dataset.position || 'left',
      intervalMs: n(this.dataset.intervalMs, 12000),
      displayMs: n(this.dataset.displayMs, 6000),
      startDelayMs: n(this.dataset.startDelayMs, 2000),
      enableTime: b(this.dataset.enableTime),
      usersRaw: this.dataset.usersRaw || '',
      timesRaw: this.dataset.timesRaw || '',
      pageType: this.dataset.pageType || '',
      pages: {
        home: b(this.dataset.showHome),
        product: b(this.dataset.showProduct),
        collection: b(this.dataset.showCollection),
        article: b(this.dataset.showArticle),
        blog: b(this.dataset.showBlog),
        cart: b(this.dataset.showCart),
        other: b(this.dataset.showOther)
      }
    };
  }

  readProducts() {
    try {
      return JSON.parse(this.querySelector('[data-products-json]').textContent || '[]');
    } catch {
      return [];
    }
  }

  parseList(raw, fallback) {
    return raw
      ? raw.split('|').map(s => s.trim()).filter(Boolean)
      : [fallback];
  }

  isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  shouldShowOnThisPage() {
    const t = this.cfg.pageType;
    if (t === 'index') return this.cfg.pages.home;
    if (t === 'product') return this.cfg.pages.product;
    if (t === 'collection') return this.cfg.pages.collection;
    if (t === 'article') return this.cfg.pages.article;
    if (t === 'blog') return this.cfg.pages.blog;
    if (t === 'cart') return this.cfg.pages.cart;
    return this.cfg.pages.other;
  }

  start() {
    this.showOne();
    this.timer = setInterval(() => this.showOne(), this.cfg.intervalMs);
  }

  showOne() {
    if (this.__closed) return;

    const product = this.pick(this.products);
    const user = this.pick(this.users);
    const time = this.cfg.enableTime ? this.pick(this.times) : '';

    this.render(user, product, time);

    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => this.hide(), this.cfg.displayMs);
  }

  pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  render(user, product, time) {
    this.innerHTML = `
      <div class="popup-notification-card is-show">
        <a class="popup-notification-link" href="${product.url}">
          <img class="popup-notification-img" src="${product.image}" alt="">
          <div class="popup-notification-content">
            <div class="popup-notification-title">
              <span>${this.escape(user)}</span> compró
              <span>${this.escape(product.title)}</span>
            </div>
            ${time ? `<div class="popup-notification-meta">${this.escape(time)}</div>` : ``}
          </div>
        </a>
        <button class="popup-notification-close icon-close"></button>
      </div>
    `;

    this.querySelector('.popup-notification-close')
  ?.addEventListener('click', () => this.closeForever());
  }

  hide() {
    this.querySelector('.popup-notification-card')
      ?.classList.remove('is-show');
  }
  closeForever() {
    this.__closed = true;
    clearInterval(this.timer);
    clearTimeout(this.hideTimer);
    this.hide();
  }

  escape(str) {
    return String(str)
      .replaceAll('&','&amp;')
      .replaceAll('<','&lt;')
      .replaceAll('>','&gt;')
      .replaceAll('"','&quot;')
      .replaceAll("'",'&#39;');
  }
}

customElements.define('popup-notification', PopupNotification);

document.addEventListener('shopify:section:load', e => {
  e.target.querySelectorAll('popup-notification')
    .forEach(el => el.connectedCallback());
});
